import React from 'react';
import { Box, Container } from '@mui/material';
import { LaboratoryRouter } from '../components/laboratory';
import { useAuth } from '../contexts/AuthContext';

const LaboratoryDashboardPage: React.FC = () => {
  const { user } = useAuth();

  if (!user) {
    return null;
}

  return (
    <Container maxWidth={false} sx={{ py: 2 }}>
      <Box sx={{ minHeight: '100vh' }}>
        <LaboratoryRouter userId={user.id} />
      </Box>
    </Container>
  );
};

export default LaboratoryDashboardPage; 